/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum BenefitStatus {
  IN_CART = 'IN_CART',
  AWAITING_MEDICAL = 'AWAITING_MEDICAL',
  READY_TO_APPLY = 'READY_TO_APPLY',
  AWAITING_EMPLOYEE = 'AWAITING_EMPLOYEE',
  CARRIER_APPLICATION_SENT = 'CARRIER_APPLICATION_SENT',
  AWAITING_PAYMENT = 'AWAITING_PAYMENT',
  ENROLLMENT_CONFIRMED = 'ENROLLMENT_CONFIRMED',
  ACTIVE = 'ACTIVE',
  ENDED = 'ENDED',
}
